import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import 'antd-mobile/es/global';
import './index.css';
import App from './App.js';
import PolarisApp from './polaris.js';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const isPolarisRoute = window.location.pathname.startsWith('/polaris');
const RootComponent = isPolarisRoute ? PolarisApp : App;

const AppWithProviders = () => {
  if (isPolarisRoute) {
    return <RootComponent />;
  }
  if (!CLIENT_ID) return <RootComponent />;
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <RootComponent />
    </GoogleOAuthProvider>
  );
};

root.render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
);
